<template>
    <div class="guide-panel-wrapper">
        <GuideWidgetWrapper
            v-for="(widget, index) in widgets"
            :key="index"
            :widget="widget"
            @tranferContent="tranferContent"
            @deleteContent="deleteContent"
            @updateContent="updateContent"
        ></GuideWidgetWrapper>
        <GuideMore @addContent="addContentHandle"></GuideMore>
    </div>
</template>

<script>
import { uniqueId, genIndexSearchHandler } from "@/views/zhiji/js/common/util.js";
import GuideMore from "./GuideMore";
import GuideWidgetWrapper from "./GuideWidgetWrapper";

export default {
    name: "GuidePanel",
    props: ["widget"],
    components: {
        GuideMore,
        GuideWidgetWrapper
    },
    data() {
        return {
            guideLabel: "",
            widgets: this.widget || initWidget()
        };
    },
    watch: {
        widgets: {
            handler(data) {
                this.$emit("guideDataHandle", data);
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        addContentHandle(data) {
            this.widgets.push(data);
        },
        deleteContent(data) {
            widgetUpdate(this.widgets, data);
        },
        tranferContent(data) {
            widgetUpdate(this.widgets, data);
        },
        updateContent(data) {
            widgetUpdate(this.widgets, data);
        }
    }
};

function initWidget() {
    return [
        {
            uId: uniqueId(),
            updateState: "add",
            wtType: "GuidePicture",
            image: "",
            content: "",
            float: "mid"
        },
        {
            uId: uniqueId(),
            updateState: "add",
            wtType: "GuideText",
            image: "",
            content: "",
            float: "mid"
        }
    ];
}

function widgetUpdate(widgets, data) {
    const handlers = {
        delete: deleteItem,
        update: updateItem,
        transfer: transferItem
    };

    handlers[data.updateState].call(null, widgets, data);
}

function deleteItem(widgets, data) {
    let itemIdx = genIndexSearchHandler("uId")(widgets, data.uId);
    widgets.splice(itemIdx, 1);
}

function updateItem(widgets, data) {
    let itemIdx = genIndexSearchHandler("uId")(widgets, data.uId);
    widgets.splice(itemIdx, 1, data);
}

function transferItem(widgets, data) {
    let itemIdx = genIndexSearchHandler("uId")(widgets, data.uId);

    if (data.newIdx < 0 || data.newIdx === itemIdx) {
        return;
    }

    const item = widgets[itemIdx];
    widgets.splice(itemIdx, 1);
    widgets.splice(data.newIdx, 0, item);
}
</script>

<style lang="less" scoped>
.guide-panel-wrapper {
    position: relative;
    margin-top: -25px;
    margin-left: 46px;
}
</style>
